import React from "react";

// `continued`: the next row is from the same sender (tight spacing, no avatar).
const DEFAULT_ROWS = [
  { side: "host", width: 44, continued: true },
  { side: "host", width: 62 },
  { side: "mine", width: 52 },
  { side: "host", width: 70 },
  { side: "mine", width: 38 },
];

const ChatSkeleton = ({ rows = DEFAULT_ROWS, label }) => (
  <div
    className="host-chat__skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    {label ? <span className="host-chat__sr-only">{label}</span> : null}
    {rows.map(({ side, width, continued }, index) => (
      <div
        key={index}
        className={`host-chat__skeleton-row is-${side}${continued ? " is-continued" : ""}`}
        aria-hidden="true"
      >
        {side === "host" && <span className="host-chat__skeleton-avatar" />}
        <span
          className="host-chat__skeleton-bubble"
          style={{ width: `${width}%` }}
        />
      </div>
    ))}
  </div>
);

export default ChatSkeleton;
